const isFinite = (x) => Number.isFinite(x);
export default isFinite;
